module.exports = __webpack_public_path__ + "img/40_38_033_041.07092c77.jpg";